// Audit logs (API AuditLogController, route api/audit-logs). Enums travel as numbers.

// AuditKind
export const AUDIT_KIND_ADMIN_CHANGE = 1;
export const AUDIT_KIND_LEARNING_ACTIVITY = 2;
export const AUDIT_KIND_SIGN_IN = 3;
export const AUDIT_KIND_SYSTEM = 4;

export const AUDIT_KIND_LABELS = {
  [AUDIT_KIND_ADMIN_CHANGE]: "audit_kind_admin_change",
  [AUDIT_KIND_LEARNING_ACTIVITY]: "audit_kind_learning_activity",
  [AUDIT_KIND_SIGN_IN]: "audit_kind_sign_in",
  [AUDIT_KIND_SYSTEM]: "audit_kind_system",
};

export const AUDIT_LOG_PAGE_SIZE = 50;
export const AUDIT_EXPORT_LIMIT = 50000;
// Entries are kept this long (AuditLogRetention.Days in the API); the API clamps "from" to it.
// The Enterprise info carries the same number as auditLogRetentionDays.
export const AUDIT_RETENTION_DAYS = 365;

export const AUDIT_RANGE_LAST_7_DAYS = "last7";
export const AUDIT_RANGE_LAST_30_DAYS = "last30";
export const AUDIT_RANGE_LAST_90_DAYS = "last90";
export const AUDIT_RANGE_LAST_365_DAYS = "last365";
export const AUDIT_RANGE_CUSTOM = "custom";

export const AUDIT_RANGE_DAYS = {
  [AUDIT_RANGE_LAST_7_DAYS]: 7,
  [AUDIT_RANGE_LAST_30_DAYS]: 30,
  [AUDIT_RANGE_LAST_90_DAYS]: 90,
  [AUDIT_RANGE_LAST_365_DAYS]: 365,
};

export const AUDIT_RANGE_LABELS = {
  [AUDIT_RANGE_LAST_7_DAYS]: "audit_range_last_7_days",
  [AUDIT_RANGE_LAST_30_DAYS]: "audit_range_last_30_days",
  [AUDIT_RANGE_LAST_90_DAYS]: "audit_range_last_90_days",
  [AUDIT_RANGE_LAST_365_DAYS]: "audit_range_last_365_days",
  [AUDIT_RANGE_CUSTOM]: "audit_range_custom",
};

// The tag of each action (AuditActions): an icon and a tone, always shown with the action's text.
export const AUDIT_ACTION_TAGS = {
  Created: { icon: "pi-plus", tone: "created" },
  Updated: { icon: "pi-pencil", tone: "updated" },
  Deleted: { icon: "pi-trash", tone: "deleted" },
  Deactivated: { icon: "pi-ban", tone: "deleted" },
  Activated: { icon: "pi-check", tone: "created" },
  Reset: { icon: "pi-refresh", tone: "reset" },
  Uploaded: { icon: "pi-upload", tone: "created" },
  Started: { icon: "pi-play", tone: "updated" },
  Completed: { icon: "pi-check-circle", tone: "created" },
  Earned: { icon: "pi-star", tone: "created" },
  Enrolled: { icon: "pi-check", tone: "created" },
  Sent: { icon: "pi-send", tone: "neutral" },
  "Signed in": { icon: "pi-sign-in", tone: "neutral" },
  "Sign-in failed": { icon: "pi-times-circle", tone: "deleted" },
  Failed: { icon: "pi-times-circle", tone: "deleted" },
  "Signed out": { icon: "pi-sign-out", tone: "neutral" },
  Exported: { icon: "pi-download", tone: "neutral" },
  Downloaded: { icon: "pi-download", tone: "neutral" },
  "Password reset": { icon: "pi-key", tone: "reset" },
  "Switched on": { icon: "pi-check", tone: "created" },
  "Switched off": { icon: "pi-power-off", tone: "reset" },
};
export const AUDIT_ACTION_TAG_DEFAULT = { icon: "pi-circle", tone: "neutral" };

// en.json message of each error code the API answers.
export const AUDIT_ERROR_MESSAGES = {
  AUDIT_EXPORT_TOO_LARGE: "audit_export_too_large",
};

// The Anyone filter's System choice: rows nobody signed in made (AuditLogs.UserId Guid.Empty).
export const AUDIT_SYSTEM_USER_ID = "00000000-0000-0000-0000-000000000000";

// What the API shows in place of a secret (AuditSecrets.Hidden).
export const AUDIT_HIDDEN = "(hidden)";
